import React, { useState } from "react";

// bootstrap
import { Col, Row, Spinner } from "react-bootstrap";
import FeatherIcon from "feather-icons-react";

import FormPurchaseOrdersProductsTable from "./FormProduct/FormPurchaseOrdersProductsTable";
import { addCart } from "utlis/Apis/Cart_API";
import { toast } from "react-toastify";
import { ERROR_WHILE_CREATING_CART } from "utlis/AppMessages/AppMessages";
import { ERROR_WHILE__NAME } from "utlis/AppMessages/AppMessages";
import { UNKNOWN_ERROR_OCCURED } from "utlis/AppMessages/AppMessages";
import { setGlobalLoading } from "redux/actions/actionCommon";
import { connect } from "react-redux";

function PurchaseOrdersFormProductsView(props) {
  const { authState, formik, setLines, lines, token_id, getCart } = props;
  let total = 0
  lines.forEach(line => {
    total = total + (((line.quantity || 0) * (line.variant_price || (line.price || 0))) || (line.variant_price || (line.price || 0)))
  });
  // consts
  const loadingCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  const [productsList, setProductsList] = useState([]);
  const [column_product, setColumn_product] = useState(true);
  const [column__description, setColumn__description] = useState(true);
  const [column__quantity, setColumn__quantity] = useState(true);
  const [column__itemPrice, setColumn__itemPrice] = useState(true);
  const [column__itemTotal, setColumn__itemTotal] = useState(true);
  const [createButtonLoading, setCreateButtonLoading] = useState(false)

  // deleting
  const handleDelete = (ev) => {
    ev.preventDefault();
  };

  const goStep2 = () => {
    window.scrollTo(0, 0)
    if (lines.filter(e => e.product_name).length === 0) {
      toast.error("Select Products", {
        autoClose: 3000
      })
    } else {
      addToCart()
    }
  }

  const addToCart = () => {
    setCreateButtonLoading(true)
    const product = lines.filter(e => e.product_name)[0]
    const data = {
      temp_order_id: token_id,
      product_id: product.product_id,
      quantity: product.quantity || 1,
      variant_sku: product.variant_sku,
      mode: product.cart_id ? "update" : "new"
    }
    const headers = {
      "Authorization": `Bearer ${authState.commonToken}`,
      "Api-Token": authState.apiToken,
      "Access-Token": "",
      // "Store-Id": authState.storeId,
    }
    addCart(headers, data).then(res => {
      setGlobalLoading(false)
      setCreateButtonLoading(false)
      const cartData = res.data
      if (cartData.success) {
        setLines(arr => [])
        getCart()

        window.scrollTo(0, 0)
        // formik.resetForm()
        // toast.dismiss();
        // toast.success(CART_ADDED_SUCCESSFULLY, {
        //   autoClose: 2000,
        //   onClose: () => {
        //   }
        // })
        props.setGoSteps(2)

      }
      if (cartData.error) {
        console.log(ERROR_WHILE_CREATING_CART, res)
        // setCreateButtonLoading(false)
        toast.dismiss();
        toast.error(cartData.message || ERROR_WHILE_CREATING_CART, {
          autoClose: 3000,
        })

        // props.setGoSteps(2) //remove later

      }
    }).catch(err => {
      console.log(`${ERROR_WHILE__NAME} createCart `, err.message)
      toast.dismiss();
      toast.error(UNKNOWN_ERROR_OCCURED, {
        autoClose: 2500,
        onClose: () => {
          setGlobalLoading(false)
          // setCreateButtonLoading(false)
        }
      })
    })
  }

  return (
    <React.Fragment>
      <div id="sale-order-product">
        <div
          id="app-saleOrder-card"
          className="app-card mb-3 mb-lg-4"
        >
          <div className="app-header-wrapper mb-2" >
            <p className="app-heading text-capitalize app-heading-bold app-heading-label mb-0">Add Products</p>
          </div>
        </div>
        <div className="app-content-container">
          <div className="app-card saleOrders-card st-border-light border st-default-rounded-block st-border-light pad-15-B">
            <div className="app-card-content st-default-rounded-block">
              <div className="st-listing-table saleOrders-table st-default-rounded-block">
                <FormPurchaseOrdersProductsTable
                  setLines={setLines}
                  lines={lines}
                  formik={formik}
                  column_product={column_product}
                  column__description={column__description}
                  column__quantity={column__quantity}
                  column__itemPrice={column__itemPrice}
                  column__itemTotal={column__itemTotal}
                  loadingCount={loadingCount}
                  productsList={productsList}
                  setColumn_product={(bool) => setColumn_product(bool)}
                  setColumn__description={(bool) => setColumn__description(bool)}
                  setColumn__quantity={(bool) => setColumn__quantity(bool)}
                  setColumn__itemPrice={(bool) => setColumn__itemPrice(bool)}
                  setColumn__itemTotal={(bool) => setColumn__itemTotal(bool)}
                  handleDelete={(ev, id) => handleDelete(ev, id)}
                  setProductsList={setProductsList}
                />
              </div>
            </div>
            <Row>
              <Col>
                <button
                  type="button"
                  className={`st-btn no-min-width st-btn-gray st-btn-sm  no-min-width d-flex align-items-center justify-content-center btn-add-product`}
                  onClick={() => {
                    setLines(arr => [...arr, {}])
                  }}
                >
                  <FeatherIcon
                    icon="plus-circle"
                    color="#0d6efd"
                    size="14"
                    className="icon me-1"
                  />
                  <span>Add Line</span>
                </button>
              </Col>

              {/* <Col> */}
              {/* <button
                  type="submit"
                  className={`st-btn no-min-width st-btn-gray st-btn-sm no-min-width d-flex align-items-center justify-content-left btn-add-save`}
                // disabled={createButtonDisable}
                // onClick={backClickHandler}
                >
                  <span>Add Purchases Tax</span>
                </button>
              </Col> */}
            </Row>
            <Row>
              <Col xs={12} md={9} lg={6}></Col>
              <Col xs={12} md={9} lg={6}>
                <Row>
                  <Col xs={6} md={9} lg={6} className="justify-content-end d-flex">
                    <div
                      className={`no-min-width no-min-width d-flex  justify-content-end label-total-amount`}
                    >
                      <span>Total</span>
                    </div>
                  </Col>
                  <Col xs={6} md={9} lg={6}>
                    <div
                      className={` no-min-width no-min-width d-flex align-items-center justify-content-left label-total-text`}
                    >
                      <span>${total || 0}</span>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            {/* <Row>
              <Col xs={12} md={9} lg={6}></Col>
              <Col xs={12} md={9} lg={6}>
                <Row>
                  <Col xs={6} md={9} lg={6} className="justify-content-end d-flex">
                    <div
                      className={`no-min-width no-min-width d-flex  justify-content-end label-balance-due`}
                    >
                      <span>Balance Due</span>
                    </div>
                  </Col>
                  <Col xs={6} md={9} lg={6}>
                    <div
                      className={` no-min-width no-min-width d-flex align-items-center justify-content-left btn-balance-due`}
                    >
                      <span>$0</span>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row> */}
          </div>
          <div className="app-card-content bg-white  d-flex align-items-center justify-content-end mt-3">
            <button
              type="submit"
              className={`st-btn no-min-width st-btn-gray st-btn-sm  no-min-width d-flex align-items-center justify-content-center me-2`}
              onClick={() => { props.setGoSteps(0) }}
              disabled={createButtonLoading}
            >
              <FeatherIcon
                icon="arrow-left"
                size="14"
                className="icon me-1"
              />
              {
                createButtonLoading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  <span>Back</span>
                )
              }
            </button>
            <button
              type="submit"
              // className={`st-btn st-btn-primary d-flex align-items-center justify-content-center ${(createButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}`}
              className={`st-btn no-min-width st-btn-primary st-btn-sm  no-min-width d-flex align-items-center justify-content-center ${createButtonLoading ? "disabled" : ""}`}
              disabled={createButtonLoading}
              onClick={() => {
                goStep2()
                // props.setGoSteps(2)
              }}
            >
              {
                createButtonLoading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  <span>Next</span>
                )}
              <FeatherIcon
                icon="arrow-right"
                size="14"
                className="icon ms-1"
              />
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const getDataFromStore = state => {
  return {
    authState: state.auth,
    sideBarVisibility: state.common.sideBarVisibility
  };
}

const dispatchActionsToProps = dispatch => {
  return {
    setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
  }
}

export default connect(getDataFromStore, dispatchActionsToProps)(PurchaseOrdersFormProductsView)